import styled from 'styled-components';

export const StyledButton = styled.button`
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 0.625rem;
  cursor: pointer;
  background: var(--rg-primary-color, #232323);
  color: var(--rg-text-on-primary, #ffffff);
  transition:
    background 0.2s ease,
    transform 0.15s ease;

  &:hover {
    background: var(--rg-primary-hover, #3a3a3a);
  }

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    cursor: not-allowed;
    background: #e8e9eb;
    color: #72767e;

    &:hover {
      background: #e8e9eb;
    }

    &:active {
      transform: none;
    }
  }
`;
